import React from 'react'
import cx from 'classnames'

import { SvgIcon } from '../svg-icon'

import styles from './status-icon.module.css'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a status icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <Status04Icon width={12} />
 */
const Status04Icon = ({ className, ...props }) => (
    <SvgIcon {...props} className={cx(className, styles['status-04-icon'])} inheritColor>
        <path
            className={styles['outer']}
            d="M24,39A15,15,0,1,1,39,24,15,15,0,0,1,24,39M24,5.5A18.5,18.5,0,1,0,42.5,24,18.5,18.5,0,0,0,24,5.5"
        />
        <path
            d={`M24,12A12,12,0,1,0,36,24,12,12,0,0,0,24,12Zm1.86,4-.52,10.58H22.68L22.17,16ZM24,32h0a2.13,2.13,0,1,1,
                2.12-2.13A2,2,0,0,1,24,32Z`}
        />
    </SvgIcon>
)

Status04Icon.defaultProps = defaultProps

export { Status04Icon }
